import { render, staticRenderFns } from "./AddendumItem.vue?vue&type=template&id=61f964ca&scoped=true&"
import script from "./AddendumItem.vue?vue&type=script&lang=js&"
export * from "./AddendumItem.vue?vue&type=script&lang=js&"
import style0 from "./AddendumItem.vue?vue&type=style&index=0&id=61f964ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f964ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61f964ca')) {
      api.createRecord('61f964ca', component.options)
    } else {
      api.reload('61f964ca', component.options)
    }
    module.hot.accept("./AddendumItem.vue?vue&type=template&id=61f964ca&scoped=true&", function () {
      api.rerender('61f964ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/review/AddendumItem.vue"
export default component.exports